import * as React from "react";
import * as ReactDOM from "react-dom";

const mountProductCatalog = (): void => {
  document.addEventListener("DOMContentLoaded", async () => {
    const catalogCategoryRoot = document.querySelector(
      "#product-catalog-category"
    );

    if (catalogCategoryRoot instanceof HTMLElement) {
      const { ProductCatalogCategory } = await import(
        /* webpackPrefetch: true */
        "../src/product_catalog/product_catalog_category"
      );

      const baseUrl = catalogCategoryRoot.dataset.baseUrl;
      if (baseUrl === undefined) {
        console.error(
          "Variable baseUrl must be defined for ProductCatalog by data-base-url"
        );
        return;
      }

      const categoryIdString = catalogCategoryRoot.dataset.categoryId;
      if (categoryIdString === undefined) {
        console.error(
          "Category to show in ProductCatalog not defined by data-category-id"
        );
        return;
      }
      const categoryId = parseInt(categoryIdString);

      const appliedSeoUrlFilters =
        catalogCategoryRoot.dataset.appliedSeoUrlFilters;
      let appliedSeoUrlFiltersObject;

      if (typeof appliedSeoUrlFilters === "string") {
        appliedSeoUrlFiltersObject = JSON.parse(appliedSeoUrlFilters);
      }

      const categorySeoAttributes =
        catalogCategoryRoot.dataset.categorySeoAttributes;
      let categorySeoAttributesObject;

      if (typeof categorySeoAttributes === "string") {
        categorySeoAttributesObject = JSON.parse(categorySeoAttributes);
      }

      const membersOnlyProductsRaw =
        catalogCategoryRoot.dataset.membersOnlyProducts;
      let membersOnlyProductsObject: Record<string, number> = {};

      if (typeof membersOnlyProductsRaw === "string") {
        try {
          membersOnlyProductsObject = JSON.parse(membersOnlyProductsRaw);
        } catch {
          console.error(
            "Invalid JSON in data-members-only-products:",
            membersOnlyProductsRaw
          );
        }
      }
      ReactDOM.render(
        <ProductCatalogCategory
          baseUrl={baseUrl}
          categoryId={categoryId}
          appliedSeoUrlFilters={appliedSeoUrlFiltersObject}
          categorySeoAttributes={categorySeoAttributesObject}
          membersOnlyProducts={membersOnlyProductsObject}
        />,
        catalogCategoryRoot
      );
    }
  });
};

mountProductCatalog();
